/**
 * created by tian ruo jun
 标题图插件
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import "./Titlepicfile.css"

export default class Titlepicfile extends Component {
    static defaultProps = {
        src:"",
        style:{
            width:100,
            height:100
        }
    };
    static propTypes = {
        src:PropTypes.string.isRequired,
        style:PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {src, style} = this.props;
        return (
            <div style={{...style}}>
                <div className={'bg'} style={{backgroundImage: `url(${src})`, borderRadius: this.props.borderRadius?this.props.borderRadius:0}}>
                    <img className={'drag'} src={src}/>
                </div>
            </div>
        )
    }

}